const internships = {
  aiML: {
    title: "AI / ML Industry Internship",
    shortTitle: "AI / ML Internship",
    duration: "8 Weeks",

    tagline: "Learn AI. Build Real Projects. Deploy Your Skills.",

    description:
      "A practical AI and Machine Learning internship designed for students who want to learn by building real-world applications and confidently present their work.",

    technologies: [
      "Python",
      "NumPy",
      "Pandas",
      "Scikit-learn",
      "Machine Learning",
      "Data Science",
      "React",
      "Node.js",
      "MongoDB",
      "Git & GitHub"
    ],

    learning: [
      "Python for AI and Machine Learning",
      "Data preprocessing and exploratory data analysis",
      "Supervised and unsupervised learning",
      "Model training and evaluation",
      "Feature engineering",
      "Building ML APIs",
      "React dashboard integration",
      "Git and GitHub",
      "Project deployment",
      "Project documentation and viva preparation"
    ],

    benefits: [
      "Industry-oriented training",
      "Hands-on project development",
      "GitHub repository",
      "Dataset and ML model",
      "Project deployment",
      "Project documentation",
      "PPT and presentation support",
      "Viva preparation",
      "Internship completion certificate"
    ],

    roadmap: [
      {
        week: "Week 1",
        title: "Python & AI Fundamentals",
        description:
          "Python fundamentals, NumPy, Pandas and introduction to Machine Learning."
      },
      {
        week: "Week 2",
        title: "Data Preparation",
        description:
          "Data collection, cleaning, preprocessing, visualization and exploratory analysis."
      },
      {
        week: "Week 3",
        title: "Machine Learning",
        description:
          "Classification, regression, clustering and selecting appropriate algorithms."
      },
      {
        week: "Week 4",
        title: "Model Development",
        description:
          "Train models, evaluate performance and improve model accuracy."
      },
      {
        week: "Week 5",
        title: "Project Development",
        description:
          "Start implementing the selected AI/ML final-year project."
      },
      {
        week: "Week 6",
        title: "Web Integration",
        description:
          "Connect the ML model with APIs and build the project dashboard."
      },
      {
        week: "Week 7",
        title: "Testing & Deployment",
        description:
          "Testing, debugging, deployment and GitHub project management."
      },
      {
        week: "Week 8",
        title: "Documentation & Viva",
        description:
          "Complete documentation, PPT, project presentation and viva preparation."
      }
    ],

    projectDomains: [
      "Student Performance Prediction",
      "Student Placement Prediction",
      "Insurance Fraud Detection",
      "Loan Approval Prediction",
      "Customer Churn Prediction",
      "Sales Forecasting",
      "Real Estate Price Prediction",
      "Resume Screening",
      "Recommendation Systems",
      "Healthcare Prediction"
    ],

    packages: [
  {
    name: "Basic Project",
    price: 1999,
    description: "Guided academic project development.",
    features: [
      "Project source code",
      "Dataset",
      "Basic documentation",
      "Project explanation",
      "PPT preparation support"
    ]
  },
  {
    name: "AI/ML Internship",
    price: 2999,
    popular: true,
    description: "Practical AI/ML training with guided project development.",
    features: [
      "8-week AI/ML internship",
      "Python and Machine Learning training",
      "Guided final-year project",
      "GitHub repository",
      "Dataset and trained ML model",
      "Project deployment guidance",
      "Project documentation",
      "PPT and presentation support",
      "Viva preparation",
      "Internship completion certificate"
    ]
  },
  {
    name: "Advanced AI/ML",
    price: 4999,
    description: "Full-stack AI/ML project with advanced implementation.",
    features: [
      "Everything in AI/ML Internship",
      "Customized project development",
      "React dashboard",
      "Node.js backend",
      "MongoDB integration",
      "Advanced ML implementation",
      "Live deployment assistance",
      "Customized documentation",
      "Advanced viva support"
    ]
  }
],
    faq: [
  {
    question: "Who can join this AI/ML internship?",
    answer:
      "Students from BCA, MCA, B.Tech, BE, BSc Computer Science, MSc Computer Science and related courses can join this internship."
  },
  {
    question: "Do I need prior AI or Machine Learning knowledge?",
    answer:
      "No. The internship starts with Python and AI/ML fundamentals and gradually moves toward project development."
  },
  {
    question: "Will I get a final-year project?",
    answer:
      "Yes. Students can select an AI/ML project from the available project domains and receive guidance throughout development."
  },
  {
    question: "Will the project be deployed?",
    answer:
      "Yes. Deployment guidance is included in the Internship and Advanced packages."
  },
  {
    question: "Will I get GitHub access?",
    answer:
      "Yes. The Internship package includes a GitHub repository for your project."
  },
  {
    question: "Do you provide project documentation and PPT?",
    answer:
      "Yes. Documentation, PPT preparation and project presentation guidance are included."
  },
  {
    question: "Will I receive an internship certificate?",
    answer:
      "Yes. Students who successfully complete the internship requirements receive a Capware Systems internship completion certificate."
  },
  {
    question: "Can I customize my project?",
    answer:
      "Yes. Customized project development is available with the Advanced package."
  }
]
  }
};

export default internships;